import React from 'react';
import './Loading.css'

const Loading = () => {
    return (
        <div className='loadingbody'>
            <div class="loading">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    );
};

export default Loading;